// src/services/customerService.js
import axios from 'axios';

import API_BASE_URL from '../../utils/config';

// Base URL of your backend API

export async function getCustomerById(id) {
      const token = localStorage.getItem('token');

  try {
    const response = await axios.get(`${API_BASE_URL}/api/customers/${id}`, {
          headers: { Authorization: `Bearer ${token}` }
        });
    return response.data;
  } catch (error) {
    console.error('Error fetching customer:', error);
    return null;
  }
}

// ✅ New: update customer
export async function updateCustomer(id, data) {
          const token = localStorage.getItem('token');

  const res = await axios.put(`${API_BASE_URL}/api/customers/${id}`, data, {
          headers: { Authorization: `Bearer ${token}` }
        });
  return res.data;
}

// 4️⃣ Get orders for a specific customer (Orders tab)
export async function getOrdersByCustomerId(customerId) {
            const token = localStorage.getItem('token');
  const res = await axios.get(`${API_BASE_URL}/api/orders/sales/${customerId}`, {
          headers: { Authorization: `Bearer ${token}` }
        });
  return res.data;
}

// 6️⃣ Get credit notes for customer (Credit Notes tab)
export async function getCustomerCreditNotes(customerId) {
              const token = localStorage.getItem('token');

  const res = await axios.get(`${API_BASE_URL}/api/credit?customer_id=${customerId}`, {
          headers: { Authorization: `Bearer ${token}` }
        });
  return res.data;
}